const getNotifications = state => state.notifications.all || []
const getRequestPending = state => state.notifications.isPending

export const notificationSelectors = {
    getNotifications,
    getRequestPending,
}
